import { IFixedNumber } from "../entities/manhattan/freeNumber/types";
import { splice } from "../utilites/strings";
import { StartFixedNumberExceptions } from "../constants/StartFixedNumberExceptions";

export const putCharAfterPostalNumber = (
  freePhoneNumber: string,
  insertChar: string
): string => {
  if (!freePhoneNumber.includes(insertChar)) {
    if (StartFixedNumberExceptions.includes(freePhoneNumber.slice(0, 4))) {
      return splice(freePhoneNumber, 4, insertChar);
    }
    return splice(freePhoneNumber, 3, insertChar);
  }

  return freePhoneNumber;
};

export const prepareFixedNumbers = (order: any, labels: any) => {
  order.checkoutData.steps.current.data.freeFixedNumbers.forEach((item: IFixedNumber) => {
    item['label'] = labels[item.type];
    item.freeNumbers.forEach((freeNumber: any, index: number) => {
      item.freeNumbers[index] = putCharAfterPostalNumber(freeNumber, "/");
      return item.freeNumbers[index];
    });
  });

  return order;
};
